import { useAuthStore } from '@/store/authStore';
import { useEffect, useState } from 'react';

export const useAuthHydration = () => {
  const [isHydrated, setIsHydrated] = useState(useAuthStore.persist.hasHydrated());

  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      setIsHydrated(true);
      return;
    }

    const unsubHydrate = useAuthStore.persist.onFinishHydration(() => {
      setIsHydrated(true);
    });

    // Garante rehydrate no native (sessionStorage não existe no iOS/Android)
    void useAuthStore.persist.rehydrate();

    return () => {
      unsubHydrate();
    };
  }, []);

  return isHydrated;
};
